import {
  IExchangeService,
  IFetchAvailableItemsResponse,
  IFetchExchangeResponse,
  ITransactionRequest
} from 'types/exchange';
import BaseService from './BaseService';

class ExchangeService extends BaseService implements IExchangeService {
  /**
   * Fetch
   * @return {Promise}
   */
  fetchExchange = () => {
    const config = {
      url: '/exchange',
    };
    return this.doRequest<IFetchExchangeResponse>(config);
  };

  /**
   * Fetch Available items
   * @param  {Number} shopId
   * @return {Promise}
   */
  fetchAvailableItems = (shopId: number | null = null) => {
    const config = {
      url: `/exchange/availabilities?shopId=${shopId}`,
    };
    return this.doRequest<IFetchAvailableItemsResponse>(config);
  };

  /**
   * Fetch
   * @return {Promise}
   */
  sellItems = (transactionRequest: ITransactionRequest) => {
    const config = {
      url: '/exchange/sell',
      method: 'post',
      data: {
        availabilityId: transactionRequest.availabilityId,
        amount: transactionRequest.amount,
      },
    };
    return this.doRequest(config);
  };

  /**
   * Fetch
   * @return {Promise}
   */
  buyItems = (transactionRequest: ITransactionRequest) => {
    const config = {
      url: '/exchange/buy',
      method: 'post',
      data: {
        availabilityId: transactionRequest.availabilityId,
        amount: transactionRequest.amount,
      },
    };
    return this.doRequest(config);
  };
}

export { ExchangeService as default };
